import React, { useEffect, useRef, useState } from 'react';
import AdminSearchBarHeader from '../component/AdminSearchBarHeader';
import { Button, Col, Input, Row, Space, Table, Tooltip, message } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrashCan } from '@fortawesome/free-regular-svg-icons';
import qs from 'qs';
import { faArrowUpRightFromSquare, faLink } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import routes from '../../../controller/Routes';
import ShareTestModal from '../component/modal/ShareTestModal';
import { SearchOutlined, UserOutlined } from '@ant-design/icons';
import { reverse } from 'named-urls';
import { useTestStore } from "../../../store/testReducer";
import { getAdminDetail } from '../../../controller/localStroageHandler';
import { getTests } from '../../../controller/api/testServices';
import OpenTestLinkModal from '../component/modal/OpenTestLinkModal';
import { getTechnology } from '../../../controller/api/globalServices';
import dayjs from 'dayjs';
import Highlighter from 'react-highlight-words';

const Test = () => {
  const navigate = useNavigate();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [textLink, setTestLink] = useState(false);
  const [openTextLink, setOpenTextLink] = useState(false);
  const [testId, setTestID] = useState('')
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState('');
  const [technologiesList, setTechnologyList] = useState([]);
  const {
    updateTestDetail,
    updateDuration,
    updateTitle,
    updateProfile,
    updateTechnologyUsed,
    updateTest,
    clearStore
  } = useTestStore(state => state)
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
    },
  });
  const userDetail = getAdminDetail();

  useEffect(() => {
    setLoading(true)
     getTechnology({ search: '', data: 'all' }).then(res => {
          let techList = res?.data?.result?.map((tech) => ({
            text: tech.name,
            value: tech._id,
          }));
          setTechnologyList(techList)
        }).catch(err => {
          console.log("err ===> ", err)
        })
    getTests({ id: userDetail?.organization_id?._id }).then(res => {
      setData(res?.data?.tests)
      setLoading(false)
    }).catch(err => {
      console.log("err ===>", err)
    })
  }, []);

   const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);
  
    const handleSearch = (
      selectedKeys,
      confirm,
      dataIndex,
    ) => {
      confirm();
      setSearchText(selectedKeys[0]);
      setSearchedColumn(dataIndex);
    };
  
    const handleReset = (clearFilters) => {
      clearFilters();
      setSearchText('');
    };
  
    const getColumnSearchProps = (dataIndex) => ({
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
        <div style={{ padding: 8 }} onKeyDown={e => e.stopPropagation()}>
          <Input
            ref={searchInput}
            placeholder={`Search ${dataIndex}`}
            value={`${selectedKeys[0] || ''}`}
            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleSearch(selectedKeys , confirm, dataIndex)}
            style={{ marginBottom: 8, display: 'block' }}
          />
          <Space>         
            <Button 
              type="primary"
              onClick={() => handleSearch(selectedKeys , confirm, dataIndex)}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              Search
            </Button>
            <Button
              onClick={() => {
                clearFilters && handleReset(clearFilters)
                handleSearch([], confirm, dataIndex);
              }}
              size="small"
              style={{ width: 90 }}
            >
              Reset
            </Button>
            <Button
              type="link"
              size="small"
              onClick={() => {
                close();
              }}
            >
              close
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
      ),
      onFilter: (value, record) =>
        record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
      onFilterDropdownOpenChange: visible => {
        if (visible) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
      render: text =>
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        ),
    });

  const columns = [
    {
      title: 'Test Name',
      dataIndex: 'name',
      sorter: true,
      className: 'fw-medium',
      sorter: (a, b) => {
        console.log("a ===> ", a)
        return a.name.localeCompare(b.name);
      },
      ...getColumnSearchProps('name'),
    },
    {
      title: 'Test Takers',
      dataIndex: 'testTaken',
      className: 'fw-medium text-center',

      // sorter: true,
      render: (item) => (
        <span className='d-flex justify-content-center align-items-center gap-2 fw-medium '>
          {item} X <UserOutlined />
        </span>
      ),
    },
    {
      title: 'Number of Questions',
      dataIndex: '',
      // sorter: true,
      className: 'fw-medium text-center',
      render: (record) => {
        let count = 0;
        record?.test_questions?.forEach((val) => {
          count += val?.questions.length;
        });
        
        return (
          <spna className='fw-medium'>
            {count}
          </spna>
        );
      },
    },
    {
      title: 'Technology Used',
      dataIndex: 'technology',
     filterSearch: true,
      filters: technologiesList,
       onFilter: (value, record) => {
    return record.technology?.some((tech) => tech._id === value);
  },
      render: (technology) => {
        return (
          <div className='d-flex gap-2 flex-wrap p-1'>
            {technology?.map((val, index) => {
              return (
                <span
                  key={index}
                  className='skill-bg-color text-muted rounded-1 d-flex gap-1'
                  style={{
                    fontSize: '14px',
                    padding: '0px 5px',
                    cursor: 'pointer',
                  }}
                >
                  {val?.name}
                </span>
              );
            })}
          </div>
        );
      },
    },
    {
      title: 'Duration (in mins)',
      dataIndex: 'durationInMins',
      className: 'fw-medium text-center',
    },
     {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      sorter: true,
      render: (value) => dayjs(value).format('DD MMM YYYY, hh:mm A'),
         sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
      defaultSortOrder: 'descend', 
    },
    {
      title: 'Updated At',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      sorter: true,
      render: (value) => dayjs(value).format('DD MMM YYYY, hh:mm A'),
         sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
    },
    {
      title: (
        <div className='w-100 d-flex justify-content-end'>
          <Button
            className='rounded-5 fw-bold d-flex justify-content-center align-items-center fw-semibold btn-border-color text-color-custom custom-hover-btn'
            onClick={() => {
              clearStore()
              navigate(routes.admin.dashboard.test.add)
            }}
          >
            Add +
          </Button>
        </div>
      ),
      dataIndex: '',
       fixed: 'right',
    width: 150,
      render: (record) => (
        <div className='d-flex gap-3 text-color-custom justify-content-end'>
          <Tooltip title="Edit Test">
            <FontAwesomeIcon
            icon={faPenToSquare}
            style={{ cursor: 'pointer' }}
            onClick={() => {
              updateTestDetail(record?.detail);
              updateDuration(record?.durationInMins);
              updateTitle(record?.name);
              updateProfile(record?.profile);
              updateTechnologyUsed(record?.technology);
              updateTest(record?.test_questions);
              navigate(
                reverse(routes.admin?.dashboard?.test?.edit, { id: record._id })
              );
            }}
          />
          </Tooltip>
           <Tooltip title="Share Link">
          <FontAwesomeIcon
            icon={faLink}
            style={{ cursor: 'pointer' }}
            onClick={() => {
              setTestID(record?._id)
              setTestLink(true);
            }}
          />
          </Tooltip>
          <Tooltip title="Open Test Link">
          <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{ cursor: 'pointer' }} onClick={() => {
             setTestID(record?._id)
              setOpenTextLink(true);
          }} />
          </Tooltip>
          <Tooltip title="Delete Test">
          <FontAwesomeIcon
            style={{ cursor: 'pointer' }}
            icon={faTrashCan}
            onClick={() => {
            }}
          />
          </Tooltip>
        </div>
      ),
    },
  ];
  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      ...sorter,
    });

    // `dataSource` is useless since `pageSize` changed
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setData([]);
    }
  };
  return (
    <>
      <div className='w-100 h-100 p-4 bg-light'>
        <AdminSearchBarHeader search={search} setSearch={setSearch} />
        <Row align={'middle'} className='mt-4 mb-4'>
          <Col span={24} className='fs-6 fw-semibold'>
            Test
          </Col>
        </Row>
        <Table
          className='table-container'
          scroll={{
            y: 460,
            x: 1200,
          }}
          columns={columns}
          rowKey={(record) => record._id}
          dataSource={data}
          // pagination={{
          //   ...tableParams.pagination,
          //   showSizeChanger: true,
          //   total: total,
          //   showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
          // }}
          loading={loading}
        // onChange={handleTableChange}
        />
      </div>
      {textLink && <ShareTestModal textLink={textLink} setTestLink={setTestLink} testId={testId} setTestID={setTestID} />}
      {openTextLink && <OpenTestLinkModal openTextLink={openTextLink} setOpenTextLink={setOpenTextLink} testId={testId} setTestID={setTestID} />}

    </>
  );
};

export default Test;
